import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    callStatsStarted: false,
    remoteDataForCallStats: false,
};

const callStatsReducerSlice = createSlice({
    name: "callStatsReducer",
    initialState,
    reducers: {
        setCallStatsStarted(state, action) {
            state.callStatsStarted = action.payload;
        },
        setRemoteDataForCallStats(state, action) {
            state.remoteDataForCallStats = action.payload;
        },
    },
});

export const { setCallStatsStarted, setRemoteDataForCallStats } = callStatsReducerSlice.actions;
export default callStatsReducerSlice.reducer;
